module.exports = __webpack_public_path__ + "static/media/saxophone.bc38e1fd.svg";